import FileUploader from './FileUploader.component';

export default FileUploader;